module.exports = __webpack_public_path__ + "img/collection-engagementRingsVintage.7e36460.webp";